<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }}<span v-if="box.extra" class="extra_price"
                                                                                 v-bind:style="[(isactive !== 'neutral' ? {visibility: 'visible'} : {visibility: 'hidden'})]"> + {{ box.extra }} €</span>
        </div>
        <!-- SEARCHBOX -->

        <!-- FILTERBOXES -->
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>
        <div class="fabric-select-btn-box">
            <div v-bind:class="[ 'top-arrow', 'hasTop', (scrollPosition > 0 && selectedScrollHeight > selectedClientHeight ? 'on' : '')]"
                 v-on:touchstart="touchstartup"v-on:mouseenter="scrollup" v-on:mouseleave="mouseleave" v-on:touchend="touchend">
                <div class="top-arrow-text"
                     v-bind:style="[(scrollPosition > 0  && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
                    {{ translations['Scroll up for further fabrics'] }}
                </div>
            </div>
            <div id="{{ box.component }}" class="fabric-select-btns" @scroll="itemsScroll">

                <div v-for="item in fabrics"
                     v-bind:class="[ 'fabric-select-btn', isactive === item.color_code ? 'active' : '' ]"
                     v-bind:id="item.color_code" @click="updatePersonal" v-bind:data-component="box.component"
                     v-bind:data-yarncolor="item.color_code">
                    <div class="fabric-select-img">
                        <span class="mask"></span>
                        <img v-bind:src="imgUrl(item.color_code)" v-bind:alt="item.name"
                             v-bind:title="item.name"/>
                    </div>
                    <div class="name">{{ item.name }}</div>
                </div>
            </div>
        </div>
        <div v-bind:class="[ 'bottom-arrow', 'hasTop', (scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? '' : 'off')]"
             v-on:touchstart="touchstartdown" v-on:mouseenter="scrolldown" v-on:mouseleave="mouseleave" v-on:touchend="touchend">
            <div class="bottom-arrow-text"
                 v-bind:style="[(scrollPosition < selectedScrollHeight - selectedClientHeight && selectedScrollHeight > selectedClientHeight ? {visibility: 'visible'} : {visibility: 'hidden'})]">
                {{ translations['Scroll down for further fabrics'] }}
            </div>
        </div>
        <div v-if="['yarncontrast'].indexOf(box.component) > -1" class="preview">
            <img v-bind:src="this.baseurl + 'media/jack/shirt/detail/yarncontrast.jpg'" width="323"
                 height="323"/>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Yarnbuttonhole',
  props: [ 'fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'isactive' ],
  data: function () {
    return {
      scrolling: false,
      touchstart: false,
      translations: window.shirtdesigner.translations,
      scrollPosition: 0,
      selectedScrollHeight: (document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0),
      selectedClientHeight: (document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0)
    }
  },
  methods: {
    updatePersonal: function (event) {
      this.$dispatch('updatePersonalData', [event.currentTarget.dataset.component, event.currentTarget.id])
      this.isactive = event.currentTarget.id
    },
    imgUrl: function (color) {
      if (color !== 'neutral') {
        return this.baseurl + 'designer/image/colorize/color/' + color + '/img/mask_buttonhole_yarn.png'
      } else {
        return this.baseurl + 'media/upload/image/dummy_product_small.jpg'
      }
    },
    scrolldown: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component)
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop + scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    scrollup: function () {
      if (this.touchstart === false) {
        var ele = document.getElementById(this.box.component)
        var speed = 25
        var scroll = 5
        var $this = this
        this.scrolling = window.setInterval(function () {
          ele.scrollTop = (ele.scrollTop - scroll)
          $this.itemsScroll()
        }, speed)
      }
    },
    mouseleave: function () {
      if (this.scrolling) {
        window.clearInterval(this.scrolling)
        this.scrolling = false
      }
    },
    touchstartup: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component)
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop - scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchstartdown: function () {
      this.touchstart = true
      var ele = document.getElementById(this.box.component)
      var speed = 25
      var scroll = 5
      var $this = this
      this.scrolling = window.setInterval(function () {
        ele.scrollTop = (ele.scrollTop + scroll)
        $this.itemsScroll()
      }, speed)
    },
    touchend: function () {
      this.mouseleave()
    },
    checkMeasures: function () {
      this.selectedScrollHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).scrollHeight : 0)
      this.selectedClientHeight = (document.getElementById(this.box.component) ? document.getElementById(this.box.component).clientHeight : 0)
    },
    itemsScroll: function () {
      var ele = document.getElementById(this.box.component)
      this.scrollPosition = ele.scrollTop
      this.checkMeasures()
    }
  },
  watch: {
    fabrics: function () {
      this.checkMeasures()
    }
  },
  ready: function () {
    this.checkMeasures()
    this.$dispatch('runDesignJQuery')
  }
}

</script>



// WEBPACK FOOTER //
// Yarnbuttonhole.vue?89e23ef6